import styled from 'styled-components';

export const StyledHiddenInput = styled.input`
  display: none;
`;

export const StyledDropZone = styled.div<{
  isDragging: boolean;
  dragDropEnabled: boolean;
}>`
  position: relative;
  display: inline-block;

  ${({ dragDropEnabled }) =>
    dragDropEnabled &&
    `
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      pointer-events: none;
      transition: all 0.2s ease;
    }
  `}

  ${({ isDragging, dragDropEnabled }) =>
    isDragging &&
    dragDropEnabled &&
    `
    &::after {
      border: 2px dashed #0066FF;
      border-radius: 4px;
      background-color: rgba(0, 102, 255, 0.05);
    }
  `}
`;
